module.exports = __webpack_public_path__ + "img/cloudPurchase_sale3.c492b1fc.png";